<template>
  <div v-if="step === 1" class="popup z-index-10-fg confirmation small-popup send-contractor-list-popup">
    <FindContractor @close="$emit('close')" :isPopupMode="true" v-model="selectedContractors" :initialAddress="getAddress()" />
    <div class="popup-footer">
      <p class="contractor-count">{{ selectedContractors.length }} Contractors Selected</p>
      <button class="text-btn" @click="$emit('close')">Cancel</button>
      <button class="square-btn" @click="sendContractors" :disabled="selectedContractors.length === 0">Confirm</button>
    </div>
  </div>
  <div v-if="step === 1" class="screen-overlay-gray z-index-10-bg"></div>
  <SendEmail v-if="step === 2" @close="$emit('close')" :lead="lead" templateId="contractorList" :selectedContractors="selectedContractors" />
</template>

<script>
import FindContractor from '@/views/FindContractor.vue';
import SendEmail from '@/components/SendEmail.vue';

export default {
  name: 'SendContractorList',
  components: {
    FindContractor,
    SendEmail,
  },
  emits: ['close', 'send-contractors'],
  props: {
    lead: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selectedContractors: [],
      step: 1,
    };
  },
  methods: {
    sendContractors() {
      if (this.selectedContractors.length > 0) {
        this.step = 2;
      }
    },
    getAddress() {
      let address = '';
      const formatAddress = (addr) => {
        if (!addr) return '';
        const parts = [];
        if (addr.LINE1) parts.push(addr.LINE1);
        if (addr.LINE2) parts.push(addr.LINE2);
        if (addr.CITY && addr.STATE) {
          parts.push(`${addr.CITY}, ${addr.STATE}`);
        }
        if (addr.POSTALCODE) {
          parts.push(addr.POSTALCODE);
        }
        return parts.join(', ');
      };

      if (this.lead.contact?.address) {
        address = formatAddress(this.lead.contact.address);
      } else if (this.lead.company?.address) {
        address = formatAddress(this.lead.company.address);
      } else if (this.lead.address) {
        address = formatAddress(this.lead.address);
      }
      return address;
    },
  },
};
</script>

<style lang="scss" scoped>
.popup.small-popup.send-contractor-list-popup {
  width: 95rem;
  height: 50rem;
  max-width: 90vw;
  max-height: 90vh;
  padding: 1px;
  display: flex;
  flex-direction: column;

  &:first-child {
    flex: 1;
  }

  .popup-footer {
    padding: 4rem 3rem 2rem 0;
  }

  .contractor-count {
    font-size: $fontSize16;
    font-weight: 600;
    color: $textColor60;
  }
}
</style>
